import Images from "../../../../../assets/images";
import globalStyles from "../../../../../assets/styles/base/globalPage.module.scss";
import {
  ChowdeckConnectIcon,
  ConnectStoreIcon,
  LumiIcon,
} from "../../../../../assets/svgIcons";
import Icon from "../../../../../assets/icons";
import primaryComponents from "../../../../../components/primaryComponents";
import secondaryComponents from "../../../../../components/secondaryComponents";
import { useNavigate, useSearchParams, useParams } from "react-router-dom";
import { pathConstants } from "../../../../../routes/pathContants";
import { useGetStoresMappingList } from "../../../../../hooks/api/queries/useMarketPlace";
import { useContext } from "react";
import { ToastContext } from "../../../../../hooks/context";
import CopyToClipboard from "react-copy-to-clipboard";
import { useQueryClient } from "react-query";
import styles from "../ConnectStore/styles.module.scss";

const SuccessConnectionModal = ({ closeModal }) => {
  const navigate = useNavigate();
  const triggerToast = useContext(ToastContext);
  const [search] = useSearchParams();
  const queryClient = useQueryClient();
  const { id } = useParams();

  const connection_id = search.get("id") || id;
  const queryText = search.get("query");

  const { data: storesMappingList } = useGetStoresMappingList({
    queries:
      queryText && queryText.length > 0
        ? `?marketplace_type=CHOWDECK&query=${queryText}`
        : "?marketplace_type=CHOWDECK",
  });
  return (
    <>
      <div className={globalStyles.pageColumnGaps}>
        <div>
          <div
            className="d-flex flex-wrap m-1 align-items-center"
            style={{ gap: "5px" }}
          >
            <img src={Images.chowdeck} height={40} width={40} alt="" />
            <ChowdeckConnectIcon />
            <LumiIcon />
            <h5>Connect Your Webhook</h5>
          </div>
          <hr style={{ marginLeft: "-20px", marginRight: "-15px" }} />
        </div>
        <div>
          <div
            style={{ gap: 8 }}
            className="d-flex flex-wrap justify-content-center"
          >
            <p>
              {
                storesMappingList?.data?.find(
                  (item) =>
                    String(item?.marketplace_conn?.id) === connection_id,
                )?.marketplace_store_name
              }
            </p>
            <ConnectStoreIcon />
            <p>
              {
                storesMappingList?.data?.find(
                  (item) =>
                    String(item?.marketplace_conn?.id) === connection_id,
                )?.lumi_store?.name
              }
            </p>
          </div>
          <div className="d-flex flex-wrap justify-content-center">
            <h6 className="small-text-size">You are almost done!</h6>
          </div>
          <div className="d-flex flex-wrap justify-content-center">
            <p className="small-text-size">
              Kindly complete these final steps below in order to complete your
              connection.
            </p>
          </div>
        </div>
        <div
          className={`${globalStyles.cardWithBorder} align-items-center m-auto`}
        >
          <div className={styles.successCard}>
            <h6>
              <span style={{ color: "red" }}>*</span>Your Webhook URL
            </h6>
            <p className="small-text-size mb-1">
              Copy your webhook url & follow the instructions below to connect
              it with chowdeck.
            </p>
          </div>
          <div
            className="d-flex flex-wrap justify-content-between align-items-center mb-3"
            style={{
              gap: "10px",
              border: "solid",
              borderColor: "#9797974D",
              padding: 10,
              borderRadius: 4,
            }}
          >
            <div>
              <p className="dark--text smallest-text-size">
                {
                  storesMappingList?.data?.find(
                    (item) =>
                      String(item?.marketplace_conn?.id) === connection_id,
                  )?.webhook_url
                }
              </p>
            </div>
            <secondaryComponents.ToolTipV2 tipText="Webwook Url">
              <CopyToClipboard
                text={
                  storesMappingList?.data?.find(
                    (item) =>
                      String(item?.marketplace_conn?.id) === connection_id,
                  )?.webhook_url
                }
                onCopy={() => triggerToast("Copied", "success")}
              >
                <primaryComponents.Button
                  classNames={"btn btn--outline smallBtn"}
                  style={{ padding: "4px 8px", height: "25px" }}
                >
                  <img width="15px" src={Icon.copy} alt="" />{" "}
                  <span className="ml-2">Copy</span>
                </primaryComponents.Button>
              </CopyToClipboard>
            </secondaryComponents.ToolTipV2>
          </div>

          <div
            className={`${globalStyles.cardWithBorder}`}
            style={{ backgroundColor: "#FAFAFA" }}
          >
            <div className="d-flex flex-wrap justify-content-center">
              <p className="default-text-size">
                How to connect your webhook url:
              </p>
            </div>
            <div className={globalStyles.pageColumnGaps}>
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "5px" }}
              >
                <img src={Icon.keysetupone} alt="" />
                <p
                  className=" d-flex justify-content-center align-items-center small-text-size dark--text"
                  style={{ gap: "1px" }}
                >
                  Login to your chowdeck:
                  <a
                    href="https://dashboard.chowdeck.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <span className="small-text-size purple--text">
                      https://dashboard.chowdeck.com
                    </span>
                  </a>
                </p>
              </div>
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "5px" }}
              >
                <img src={Icon.keysetuptwo} alt="" />
                <p className="small-text-size dark--text">Go to settings</p>
              </div>
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "5px" }}
              >
                <img src={Icon.keysetupthree} alt="" />
                <p className="small-text-size dark--text">
                  Select developer settings
                </p>
              </div>
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "5px" }}
              >
                <img src={Icon.keysetupfour} alt="" />
                <p className="small-text-size dark--text">
                  Enter the webhook url in a field titled &quot;
                  <strong>Webhook URL</strong>&quot;
                </p>
              </div>
              <div
                className="d-flex flex-wrap align-items-center"
                style={{ gap: "5px" }}
              >
                <img src={Icon.keysetupfive} alt="" />
                <p className="small-text-size dark--text">
                  Click on the button &quot;
                  <strong>Save</strong>&quot;
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-end">
          <primaryComponents.Button
            classNames="btn btn--primary mt-auto"
            type="submit"
            onClick={() => {
              queryClient.invalidateQueries(["mappedUnmappedProducts"]);
              navigate(`${pathConstants.APPS_CHOWDECK_CONNECTIONS}`);
              closeModal();
            }}
          >
            Done
          </primaryComponents.Button>
        </div>
      </div>
    </>
  );
};

export default SuccessConnectionModal;
